// 途牛直连
export const tuNiuConnectionRouter = [
  {
    path: '/service/tuNiuConnection/product',
    name: 'TuNiuProductList',
    component: () => import('@/views/service/serviceProvider/tuNiuConnection/TuNiuProductList'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/tuNiuConnection/order',
    name: 'TuNiuOrderList',
    component: () => import('@/views/service/serviceProvider/tuNiuConnection/TuNiuOrderList'),
    meta: {
      title: '订单列表',
      keepAlive: false
    }
  },
  {
    path: '/service/tuNiuConnection/apiConfigure',
    name: 'TuNiuApiConfigure',
    component: () => import('@/views/service/serviceProvider/tuNiuConnection/TuNiuApiConfigure'),
    meta: {
      title: 'API配置',
      keepAlive: false
    }
  }
]
